/**
 * P3-42: ReclaimReservesBtn —— 取回储备资源按钮。
 *
 * 对齐 `js/challenges.js:970-984`：
 * - 可见：不在任何挑战中、非 Iron Will、且存在储备
 * - 点击调用 `game.challenges.reserves.addReserves()` 后 `game.render()`
 */
import { getGame } from "../../bridge/GameBridge";
import type { GamePage } from "../../bridge/GameBridge";
import { useGameTick } from "../../bridge/useGameTick";
import { t } from "../../bridge/i18n";
import { GameButton } from "../../components/GameButton";

interface ReclaimSnapshot {
  visible: boolean;
  name: string;
  description: string;
}

function getSnapshot(game: GamePage | null): ReclaimSnapshot | null {
  if (!game) {
    return null;
  }
  const anyActive = game.challenges?.anyChallengeActive?.() ?? false;
  const hasReserves = game.challenges?.reserves?.reservesExist?.() ?? false;
  return {
    visible: !anyActive && !game.ironWill && hasReserves,
    name: t("challendge.reclaimReserves.label"),
    description: t("challendge.reclaimReserves.desc"),
  };
}

function snapEq(a: ReclaimSnapshot | null, b: ReclaimSnapshot | null): boolean {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return (
    a.visible === b.visible &&
    a.name === b.name &&
    a.description === b.description
  );
}

export default function ReclaimReservesBtn() {
  const snapshot = useGameTick(
    (game) => getSnapshot(game as GamePage | null),
    snapEq,
  );

  if (!snapshot || !snapshot.visible) {
    return null;
  }

  return (
    <GameButton
      name={snapshot.name}
      description={snapshot.description}
      getTooltip={() => snapshot.description}
      onClick={() => {
        getGame()?.challenges?.reserves?.addReserves?.();
        getGame()?.render();
      }}
    />
  );
}
